import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Recommendations from "./components/Recommendations";
import Ranking from "./components/Ranking";
import Schedule from "./components/Schedule";
import Highlights from "./components/Highlights";
import News from "./components/News";
import Guide from "./components/Guide";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <Recommendations />
        <Ranking />
        <Schedule />
        <Highlights />
        <News />
        <Guide />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}